import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const ToolbarSplateRotateIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M9.63 8H8.62C8.27758 8 8 8.27758 8 8.62V9.63C8 9.97242 8.27758 10.25 8.62 10.25H9.63C9.97242 10.25 10.25 9.97242 10.25 9.63V8.62C10.25 8.27758 9.97242 8 9.63 8Z"
        fill={color}
      />
      <path
        d="M9.63 13.75H8.62C8.27758 13.75 8 14.0276 8 14.37V15.38C8 15.7224 8.27758 16 8.62 16H9.63C9.97242 16 10.25 15.7224 10.25 15.38V14.37C10.25 14.0276 9.97242 13.75 9.63 13.75Z"
        fill={color}
      />
      <path
        d="M15.38 13.75H14.37C14.0276 13.75 13.75 14.0276 13.75 14.37V15.38C13.75 15.7224 14.0276 16 14.37 16H15.38C15.7224 16 16 15.7224 16 15.38V14.37C16 14.0276 15.7224 13.75 15.38 13.75Z"
        fill={color}
      />
      <path
        d="M15.38 8H14.37C14.0276 8 13.75 8.27758 13.75 8.62V9.63C13.75 9.97242 14.0276 10.25 14.37 10.25H15.38C15.7224 10.25 16 9.97242 16 9.63V8.62C16 8.27758 15.7224 8 15.38 8Z"
        fill={color}
      />
      <path
        d="M12.51 10.88H11.5C11.1576 10.88 10.88 11.1576 10.88 11.5V12.51C10.88 12.8524 11.1576 13.13 11.5 13.13H12.51C12.8524 13.13 13.13 12.8524 13.13 12.51V11.5C13.13 11.1576 12.8524 10.88 12.51 10.88Z"
        fill={color}
      />
      <path
        d="M6.71 17.29L4.67 19.33C2.73 17.4 1.62 14.8 1.62 12C1.62 6.28 6.28 1.62 12 1.62C12.35 1.62 12.62 1.34 12.62 1C12.62 0.660005 12.34 0.380005 12 0.380005C5.59 0.380005 0.380005 5.59 0.380005 12C0.380005 15.13 1.61 18.04 3.79 20.21L2.19 21.81C1.76 22.24 2.06001 22.98 2.68001 22.98H7.21C7.59 22.98 7.9 22.67 7.9 22.29V17.76C7.9 17.15 7.16 16.84 6.73 17.27L6.71 17.29Z"
        fill={color}
      />
      <path
        d="M20.21 3.79002L21.81 2.19002C22.24 1.76002 21.94 1.02002 21.32 1.02002H16.79C16.41 1.02002 16.1 1.33002 16.1 1.71002V6.24002C16.1 6.85002 16.84 7.16002 17.27 6.73002L19.32 4.68002C21.26 6.61002 22.36 9.21002 22.36 12.01C22.36 17.73 17.71 22.39 11.98 22.39C11.63 22.39 11.36 22.67 11.36 23.01C11.36 23.35 11.64 23.63 11.98 23.63C18.39 23.63 23.6 18.42 23.6 12.01C23.6 8.87002 22.37 5.96002 20.19 3.80002L20.21 3.79002Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolbarSplateRotateIcon.displayName = 'ToolbarSplateRotateIcon';
